import {addDelegateEventListener} from '../../../../application/helpers';
import {Api} from '../../../../application/api/api';
import {CountdownTimer} from '../timers/CountdownTimer';

class TopOfferLoader
{
    static initToggleButtons(listContentElement) {
        addDelegateEventListener(
            listContentElement,
            'click',
            '[data-action="set-top"]',
            (buttonElement, event) => {
                event.preventDefault();
                this.setTop(buttonElement, listContentElement);
            }
        );
    }

    /**
     * @param {Element} buttonElement
     * @param {Element} listContentElement
     */
    static setTop(buttonElement, listContentElement) {
        Api.post(buttonElement.getAttribute('data-endpoint'), {}, (response) => {
            if (response.isFailure()) {
                return;
            }

            let parentBlock = buttonElement.closest('[data-block="top-offer"]');
            let timerBlock = parentBlock.querySelector('[data-block="timer"]');
            timerBlock.innerHTML = response.get('content', '');
            buttonElement.classList.add('d-none');

            timerBlock.classList.remove('d-none');

            let timer = timerBlock.querySelector('[data-init="timer"]');
            new CountdownTimer(timer);
        });
    }
}

export {TopOfferLoader};
